import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { SketchPicker } from 'react-color';
import { Grid, Typography, AnalyticsComponent, AnalyticsProps, Colors } from '@inplayer-org/inplayer-ui';

// hooks
import useRestrictionRules from 'restrictions/roles/hooks/useRestrictionRules';

// constants
import Rules from 'restrictions/roles/constants/rules';

const { Container, Cell } = Grid;

const ColorContainer = styled(Container)`
  position: relative;
  align-items: center;
`;

interface ColorProps {
  backgroundColor: string;
}

const ColorWrapper = styled(Cell)`
  height: 15px;
  border-radius: 2px;
  ${({ backgroundColor }: ColorProps) => `background: ${backgroundColor}`};
  border: 1px solid ${Colors.fontLightGray};
`;

const SketchPickerWrapper = styled(Cell)`
  position: absolute;
  top: 1.5rem;
  z-index: 15;
`;

const FixedCell = styled(Cell)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

interface OwnProps extends AnalyticsProps {
  showColorPicker: any;
  displayPicker: any;
  element_name: string;
  background_color: string;
  text: string;
  handleClick: (input: string) => any;
  handleClose: (input: string) => any;
  handlePickerChange: any;
}

const PaywallConfigurationFrom: FunctionComponent<OwnProps> = ({
  showColorPicker,
  displayPicker,
  element_name,
  background_color,
  text,
  handleClick,
  handleClose,
  handlePickerChange,
  tag = '',
}) => {
  const { hasRule } = useRestrictionRules();
  const isReadOnly = hasRule(Rules.READONLY_BRANDING_THEMES);

  return (
    <ColorContainer columns={6}>
      <AnalyticsComponent>
        {({ pages, tracker, merchantId, ip }) => (
          <>
            <ColorWrapper
              backgroundColor={background_color}
              onClick={() => {
                if (!isReadOnly) {
                  handleClick(displayPicker);
                  tracker.track({
                    event: 'click',
                    type: 'color_picker',
                    tag,
                    pages,
                    merchantId,
                    ip,
                  });
                }
              }}
              width={1}
            />
            {showColorPicker ? (
              <SketchPickerWrapper>
                {/* This fixed cell is needed for closing scketch picker when user clicks out of scketch picker area */}
                <FixedCell
                  onClick={() => {
                    handleClose(displayPicker);
                  }}
                />
                <SketchPicker disableAlpha color={background_color} onChange={handlePickerChange(element_name)} />
              </SketchPickerWrapper>
            ) : null}
            <Cell width={5}>
              <Typography variant="p">{text}</Typography>
            </Cell>
          </>
        )}
      </AnalyticsComponent>
    </ColorContainer>
  );
};

export default PaywallConfigurationFrom;
